import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import "./action";

@customElement("eko-action-group")
class ActionGroup extends EkoElement {
  @property({ reflect: true }) role = "list";

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-action-group": ActionGroup;
  }
}

export default ActionGroup;
